// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './core/filters'
import mixin from './core/mixin'

import store from './store'
import router from './router'
import './registerServiceWorker'

import '@babel/polyfill'

import searchParams from 'url-search-params-polyfill'

// Plugins init
import { VLazyImagePlugin } from 'v-lazy-image'

import popup from './plugins/popup'

import overlay from './plugins/overlay'

// LANGUAGE
import i18n from './i18n'

import VueTelInput from 'vue-tel-input'

import LangSelector from '@/components/ui/LangSelector'

import Default from './layouts/Default-Layout.vue'
import Login from './layouts/Login-Layout.vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import VuejsClipper from 'vuejs-clipper'

import '@/styles/_information.scss'

// PLUGINS PROPIOS
// import popup from './plugins/popup'
// import overlay from './plugins/overlay'
// import column from './plugins/column'
// import card from './plugins/card'
// import columnFilter from './plugins/columnFilter'
import comboSelector from './plugins/comboSelector'
Vue.use(searchParams)
Vue.use(VLazyImagePlugin)
Vue.use(popup)
Vue.use(overlay)
Vue.prototype.$overlay({ loading_img: '/img/logo_new.png', color: 'rgba(19, 18, 18, 0.81)', closable: true })

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.use(i18n)
Vue.use(VueTelInput)
Vue.component('LangSelector', LangSelector)

Vue.component('default-layout', Default)
Vue.component('login-layout', Login)

Vue.use(Vuetify, { theme: false })
Vue.use(VuejsClipper)

// Vue.use(popup)
// Vue.use(overlay)
// Vue.use(column)
// Vue.use(columnFilter)
// Vue.use( card )
Vue.use(comboSelector)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>',
  mixins: [ mixin ]
  /* mounted() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', '~@/core/store.js')
    document.head.appendChild(recaptchaScript)
  }, */
})

// Shared variables

// var menu_is_visible = true;
